import { render, staticRenderFns } from "./DocsUpload.vue?vue&type=template&id=0f6bc866&"
import script from "./DocsUpload.vue?vue&type=script&lang=js&"
export * from "./DocsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports